import { useState } from 'react';
import { Table, TableBody } from '@mui/material';

import theme from 'src/styles/theme';
import { Activity } from 'src/modules/common/types';

import ActivityTableRow from '../ActivityTableRow/ActivityTableRow';

interface Props {
  data: Activity[];
}

const ActivityTable = ({ data }: Props) => {
  const [showActionId, setShowActionId] = useState('');

  return (
    <Table sx={{ tableLayout: 'auto', width: '100%', backgroundColor: theme.palette.colors.white }}>
      <TableBody>
        {data.map((activity, index) => (
          <ActivityTableRow
            key={index}
            index={index}
            data={activity}
            showActionId={showActionId}
            setShowActionId={setShowActionId}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default ActivityTable;
